import debounce from "lodash.debounce";
import { Middleware } from "redux";

import { IForm } from "../../../Form/IForm";
import { ModelHunk } from "../../ModelStoring/ModelHunk";
import { ModelActionType } from "../../ModelStoring/Store/modelActions";
import { CandyDispatch, CandyThunkAction } from "../CandyReduxTypes";
import { FullFormAction } from "../FullFormAction";

export function aggregateValuesMiddleware(form: IForm): Middleware {
    const result =
        () =>
        (next: CandyDispatch): CandyDispatch => {
            let data = ModelHunk.create();
            function flushBatch(): void {
                const filledData = data;
                data = {};
                form.setBatch(filledData);
            }

            const flushThrottled = debounce(flushBatch, 100);

            return <R>(action: FullFormAction | CandyThunkAction<R>): R | void => {
                if (typeof action === "function") {
                    return next(action);
                }
                if (action.type === ModelActionType.AggregatedSetToModel) {
                    const { bindingPath, field, value } = action.payload;
                    if (ModelHunk.hasPath(data, bindingPath)) {
                        // @ts-ignore
                        ModelHunk.updateIfExists(data, bindingPath, x => (x[field] = value));
                    } else {
                        ModelHunk.set(data, bindingPath, { [field]: value });
                    }

                    flushThrottled();
                } else {
                    return next(action);
                }
                return undefined;
            };
        };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any
    return result as any;
}
